import React, { Component } from "react";
import { Link, withRouter } from "react-router-dom";
import { GlobalContext } from "../app/providers/GlobalState";

import getAppFooterText from "../shared/utils/appFooterText";

class Footer extends Component {
    static contextType = GlobalContext;
    state = {
        semFooter: ""
    };

    componentDidMount() {
        if (
            this.props.location.pathname.split("/").pop() === "player-webinar" ||
            this.props.location.pathname.split("/").pop() === "player-videoconferencia" ||
            this.props.location.pathname.split("/").pop() === "player-video" ||
            this.props.location.pathname.split("/").pop() === "player-video-meets" ||
            this.props.location.pathname.split("/").pop() === "player-audio" ||
            this.props.location.pathname.split("/").pop() === "player-pagina" ||
            this.props.location.pathname.split("/").pop() === "player-pdf" ||
            this.props.location.pathname.split("/").pop() === "player-questionario" ||
            this.props.location.pathname.split("/").pop() === "player-questionario-resumo" ||
            this.props.location.pathname.split("/").pop() === "player-questionario-resolucao" ||
            this.props.location.pathname.split("/").pop() === "player-avaliacao" ||
            this.props.location.pathname.split("/").pop() === "player-avaliacao-resumo" ||
            this.props.location.pathname.split("/").pop() === "player-avaliacao-resolucao" ||
            this.props.location.pathname.split("/").pop() === "player-download" ||
            this.props.location.pathname.split("/").pop() === "player-trabalho" ||
            this.props.location.pathname.split("/").pop() === "player-link" ||
            this.props.location.pathname.split("/").pop() === "player-sessao-online" ||
            this.props.location.pathname.split("/").pop() === "player-sessao-presencial" ||
            this.props.location.pathname.split("/").pop() === "player-sumario" ||
            this.props.location.pathname.split("/").pop() === "player-trabalho-ficheiro" ||
            this.props.location.pathname.split("/").pop() === "player-ficheiro" ||
            this.props.location.pathname.split("/").pop() === "player-assiduidade" ||
            this.props.location.pathname.split("/").pop() === "player-sessao-persencial" ||
            this.props.location.pathname.split("/")[1] === "controller"
        )
            this.setState({
                semFooter: "sem-footer"
            });
    }

    componentDidUpdate(prevProps) {
        if (this.props.location.pathname !== prevProps.location.pathname) {
            if (
                this.props.location.pathname.split("/").pop() === "player-webinar" ||
                this.props.location.pathname.split("/").pop() === "player-videoconferencia" ||
                this.props.location.pathname.split("/").pop() === "player-video" ||
                this.props.location.pathname.split("/").pop() === "player-video-meets" ||
                this.props.location.pathname.split("/").pop() === "player-audio" ||
                this.props.location.pathname.split("/").pop() === "player-pagina" ||
                this.props.location.pathname.split("/").pop() === "player-pdf" ||
                this.props.location.pathname.split("/").pop() === "player-questionario" ||
                this.props.location.pathname.split("/").pop() === "player-questionario-resumo" ||
                this.props.location.pathname.split("/").pop() === "player-questionario-resolucao" ||
                this.props.location.pathname.split("/").pop() === "player-avaliacao" ||
                this.props.location.pathname.split("/").pop() === "player-avaliacao-resumo" ||
                this.props.location.pathname.split("/").pop() === "player-avaliacao-resolucao" ||
                this.props.location.pathname.split("/").pop() === "player-download" ||
                this.props.location.pathname.split("/").pop() === "player-trabalho" ||
                this.props.location.pathname.split("/").pop() === "player-link" ||
                this.props.location.pathname.split("/").pop() === "player-sessao-online" ||
                this.props.location.pathname.split("/").pop() === "player-sessao-presencial" ||
                this.props.location.pathname.split("/").pop() === "player-trabalho-ficheiro" ||
                this.props.location.pathname.split("/").pop() === "player-ficheiro" ||
                this.props.location.pathname.split("/").pop() === "player-assiduidade" ||
                this.props.location.pathname.split("/").pop() === "player-sessao-persencial" ||
                this.props.location.pathname.split("/")[1] === "controller"
            )
                this.setState({
                    semFooter: "sem-footer"
                });
            else
                this.setState({
                    semFooter: ""
                });
        }
    }

    render() {
        const { redessociais, fundoBranco, homeStepforma } = this.props;

        return (
            <div className={`footer ${this.state.semFooter}`} style={fundoBranco ? { background: "white" } : {}}>
                {redessociais.length > 0 && (
                    <div className="bloco-footer">
                        <ul className="redes_sociais">
                            <li>
                                <Link to="/faq" className="faq" rel="noopener noreferrer" title="FAQ">
                                    FAQ
                                </Link>
                            </li>
                        </ul>
                    </div>
                )}
                <span className="direitos">{getAppFooterText()}</span>
            </div>
        );
    }
}

export default withRouter(Footer);
